import { useRef, type CSSProperties } from 'react'
import { useMotion } from '@/components/motion/motion'
import { useInView } from '@/components/motion/useInView'
import { cx } from '@/lib/cx'

const track = [
  { when: 'First 90 days', what: 'Pricing, billing and financial control move onto one operating standard.' },
  { when: 'Then', what: 'Production moves onto Justine one service line at a time.' },
  { when: 'As capacity allows', what: 'New client books join.' },
]

/* How it adds up: the sequence after joining, then why capacity leads to acquisitions. The track
   fills in when it comes into view. */
export const AddsUpSection = () => {
  const { paused, reduceMotion } = useMotion()
  const trackRef = useRef<HTMLOListElement>(null)
  const inView = useInView(trackRef, 0.45)

  return (
    <section id="w-adds" className="w-sec w-snap" aria-labelledby="w-adds-title">
      <div className="x-wrap">
        <div className="w-head">
          <p className="x-eyebrow x-eyebrow--ink">How it adds up</p>
          <h2 id="w-adds-title" className="x-h2">
            How it adds up for your firm
          </h2>
        </div>
        <ol ref={trackRef} className={cx('w-track', (inView || paused || reduceMotion) && 'is-in')}>
          {track.map((stage, index) => (
            <li key={stage.when} style={{ '--i': index } as CSSProperties}>
              <b>{stage.when}</b>
              <p>{stage.what}</p>
            </li>
          ))}
        </ol>
        <div className="w-grow">
          <p className="w-grow-lead">More capacity and higher margins make room to grow by acquisition.</p>
          <p className="w-grow-text">
            A generation of owners is retiring and bringing their client books to market, and most firms can’t take them on
            because they can’t hire the people to serve them. A firm with capacity to spare can. United’s deal team finds the
            books, finances the deals and closes them, and each book joins your firm on the same system.
          </p>
        </div>
      </div>
    </section>
  )
}
